module.exports = __webpack_public_path__ + "assets/img/more-btn-31b04151.png";